<script setup>
import {onMounted, reactive, watch} from "vue";
import {tt} from '@/i18n';
import Statistics from "@/components/Statistics";
import ContentList from "@/components/list/ContentList";
import Filters from '@/components/list/Filters'
import PageTitle from "@/shared/PageTitle";
import LoadingSpinner from "@/shared/LoadingSpinner";
import {useContentStore} from "@/stores/ContentStore";
import useFilteredContent from "@/composables/useFilteredContent";
import {useRoute} from "vue-router";

const store = useContentStore();
const route = useRoute();

const state = reactive({
    loading: false,
});

const {filteredContent, userStat} = useFilteredContent(store);

async function getUserContent() {
    state.loading = true;
    await store.getUserContent();
    document.title = tt('tab_title__my_portal');
    state.loading = false;
}

watch(
    () => route.query,
    (query) => {
    },
    {deep: true}
);

onMounted(() => {
    getUserContent();
});
</script>

<template>
    <div class="bg-[#FBFBFD]">
        <loading-spinner v-if="state.loading"/>
        <div v-else>
            <statistics :stat="userStat"/>
            <page-title :page_title="$tt('my_portal_page__title')"/>
            <filters/>
            <content-list :content_list="filteredContent"/>
        </div>
    </div>
</template>
